import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { HttpRequestHandler, HttpRequestBase, MessageType, ErrorUtil } from '../models/http-model';
import { ToastyService } from 'ng2-toasty';
import * as xml2js from 'xml2js';
var Base64 = require('js-base64').Base64;
import { environment } from '../../../environments/environment';
import { xml } from 'd3';

declare var require: any;
const HEADERS = {};

@Injectable()
export class HttpSoap {
  static ENV = environment;
  constructor(private toast: ToastyService, private http: HttpClient) {
    HEADERS['Content-Type'] = 'application/json';
  }

  /**
   * performs a request with POST http method
   */
  public post(url: string, SOAPAction: string, data: any, httpRequestHandler: HttpRequestHandler) {
    this.setHandlerDefaults(httpRequestHandler);
    const headers = httpRequestHandler.headers;
    headers['SOAPAction'] = SOAPAction;
    this.handleResponse(this.bridge(url, data, headers), httpRequestHandler);
  }

  public postXml(url: string, SOAPAction: string, data: any, httpRequestHandler: HttpRequestHandler){
    this.setHandlerDefaults(httpRequestHandler);
    const headers = httpRequestHandler.headers;
    headers['SOAPAction'] = SOAPAction;
    this.handleResponse(this.bridge(url, data, headers), httpRequestHandler, false);
  }
  
  public get(url: string,  httpRequestHandler: HttpRequestHandler, token?: string) {
    this.setHandlerDefaults(httpRequestHandler);
    const headers = this.getHeaders(httpRequestHandler, token);      
    this.handleResponse(this.http.get(url, {headers: headers}), httpRequestHandler);
  }

  private setHandlerDefaults(httpRequestHandler: HttpRequestHandler) {
    if (httpRequestHandler.includeToken == null) httpRequestHandler.includeToken = true;
    if (httpRequestHandler.errorMsgType == null) httpRequestHandler.errorMsgType = MessageType.Toast;
  }

  private getHeaders(httpRequestBase: HttpRequestBase, token?: string) {
    const headers = {};

    if (httpRequestBase.includeToken) {
      if (httpRequestBase.headers) return httpRequestBase.headers;
      headers['Authorization'] = token;
    }
    return headers;
  }

  /**
   * handle the response for a given request
   */
  private handleResponse(request: Observable<any>, httpRequestHandler: HttpRequestHandler, json = true) {
    request
      .finally(() => {
        if (httpRequestHandler.always) { httpRequestHandler.always(); }
      })
      .subscribe(
        res => {
          if (httpRequestHandler.success) {
            try {
              if (json) {
                this.convertXmltoJson(res, false, httpRequestHandler);
              } else {
                httpRequestHandler.success(res);
              }
            } catch (e) {
              httpRequestHandler.success({});
            }
          }
        },
        err => {
          const data = this.handleError(err, httpRequestHandler.errorMsgType);
          if (httpRequestHandler.error) {
            const util: ErrorUtil = {
              err: err,
              showToastError: this.generateError.bind(this, err, MessageType.Toast, data),
              showAlertError: this.generateError.bind(this, err, MessageType.Toast, data)
            };
            httpRequestHandler.error(data, util);
          }
        }
      );
  }

 
  public convertXmltoJson(xml: any, xmlDecode?: any, httpRequestHandler?: HttpRequestHandler): any {
    xml2js.parseString(xml, (error, result) => {
      if (error) {
        if (httpRequestHandler.error) {
          const data = this.handleError(error, httpRequestHandler.errorMsgType);
          if (httpRequestHandler.error) {
            const util: ErrorUtil = {
              err: error,
              showToastError: this.generateError.bind(this, error, MessageType.Toast, data),
              showAlertError: this.generateError.bind(this, error, MessageType.Toast, data)
            };
            httpRequestHandler.error(data, util);
          }
        }
      } else {
        if (xmlDecode) {
          httpRequestHandler.success(result['DATA_DS']['G_1']);
          return;
        }
        let json = JSON.stringify(result['soapenv:Envelope']['soapenv:Body'][0]['runReportResponse'][0]['runReportReturn'][0]['reportBytes']);
   
        const base64decode = Base64.decode(json);
        this.convertXmltoJson(base64decode, true, httpRequestHandler);
      }
    });
  }

  /**
   * handle the error for the requests
   */
  private handleError(err: any, type: MessageType) {
    let data: any;
    if (err.headers && err.headers['content-type'] === 'text/xml; charset=utf-8') {
      data = err.error;
    }
    this.generateError(err, type, data);
    return data;
  }

  private generateError(err: any, type: MessageType, data: any) {
    if (type === MessageType.None) return;

    const basicError = () => {
      if (type === MessageType.Toast) this.toast.error('Se produjo un error al obtener la información. Por favor verifique su conexión a internet.');
      else if (type === MessageType.Loading) console.log('Mensaje loading');
    };
    basicError();
  }

  private bridge(url, data, headers) {
    let json = {
      url: url,
      data: data,
      headers: headers
    };
    return this.http.post(HttpSoap.ENV.environment.API.bridge_soap, json, { headers: HEADERS, responseType: 'text' });
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/http-soap.service.ts